module.exports = __webpack_public_path__ + "img/osa_iPhone.7e108d61.svg";